import { render, staticRenderFns } from "./AdminFeedback.vue?vue&type=template&id=feb36eda&scoped=true"
import script from "./AdminFeedback.vue?vue&type=script&lang=ts"
export * from "./AdminFeedback.vue?vue&type=script&lang=ts"
import style0 from "./AdminFeedback.vue?vue&type=style&index=0&id=feb36eda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb36eda",
  null
  
)

export default component.exports